import { Colors } from './Colors';

export const Tabs = {
  MuiTabs: {
    styleOverrides: {
      indicator: {
        backgroundColor: 'transparent',
      },
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          color: `${Colors.white} !important`,
          background: Colors.secondaryColor,
        },
      },
    }
  },
};
